import type { ReactNode } from 'react';

type Props = {
    title: string;
    onClose: () => void;
    children: ReactNode;
    /** Optional: pin a footer that does not scroll with the body. */
    footer?: ReactNode;
};

/**
 * Generic modal shell.
 *
 * Tap-outside dismiss is intentionally disabled on the popup itself: forms
 * inside (withdraw, create-task) are easy to bump while filling, and the
 * close-X is always reachable in the header. Tapping the overlay still
 * closes, which matches the iOS sheet metaphor.
 */
export function Modal({ title, onClose, children, footer }: Props) {
    return (
        <div className="overlay" onClick={onClose} role="dialog" aria-modal="true">
            <div className="popup" onClick={(e) => e.stopPropagation()}>
                <div className="popup-header">
                    <span className="popup-title">{title}</span>
                    <button
                        type="button"
                        className="popup-close"
                        aria-label="Закрыть"
                        onClick={onClose}
                    >
                        ✕
                    </button>
                </div>
                <div className="popup-body">{children}</div>
                {footer}
            </div>
        </div>
    );
}
